module.exports = __webpack_public_path__ + "static/media/ProductSettings_color.2f844883.svg";